import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const INITIAL = { name: "", email: "", phone: "", message: "" };

const inputClass =
  "w-full bg-transparent border-b border-black/[0.12] focus:border-[#DBB89C] outline-none py-4 text-base tracking-wide placeholder:text-[#908B85]/60 transition-colors duration-300";

export const EnquiryForm = () => {
  const [form, setForm] = useState(INITIAL);
  const [sending, setSending] = useState(false);

  const update = (key) => (e) => setForm({ ...form, [key]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await axios.post(`${API}/enquiries`, form);
      toast.success("Your enquiry has been received. Caitlin will be in touch within one business day.");
      setForm(INITIAL);
    } catch (err) {
      toast.error("Something went wrong. Please call or email us directly.");
    } finally {
      setSending(false);
    }
  };

  return (
    <form onSubmit={submit} data-testid="contact-form" className="overflow-hidden bg-white rounded-[4px] border border-black/[0.08] shadow-[0_4px_40px_-10px_rgba(0,0,0,0.06)]">
      <div className="plaid h-2.5 w-full" aria-hidden="true" />
      <div className="space-y-8 p-8 md:p-12">
      <input
        required
        value={form.name}
        onChange={update("name")}
        placeholder="Full name"
        data-testid="contact-name-input"
        className={inputClass}
      />
      <input
        required
        type="email"
        value={form.email}
        onChange={update("email")}
        placeholder="Email address"
        data-testid="contact-email-input"
        className={inputClass}
      />
      <input
        value={form.phone}
        onChange={update("phone")}
        placeholder="Phone (optional)"
        data-testid="contact-phone-input"
        className={inputClass}
      />
      <textarea
        required
        rows={4}
        value={form.message}
        onChange={update("message")}
        placeholder="Tell us about the property, the timeline, and what matters most to you."
        data-testid="contact-message-input"
        className={`${inputClass} resize-none`}
      />
      <button
        type="submit"
        disabled={sending}
        data-testid="contact-submit-button"
        className="group inline-flex items-center gap-4 rounded-full bg-[#DBB89C] text-white px-8 py-4 text-xs font-semibold tracking-[0.25em] uppercase transition-colors duration-300 hover:bg-[#493E38] disabled:opacity-50"
      >
        {sending ? "Sending…" : "Submit Enquiry"}
        <ArrowRight
          size={16}
          className="transition-transform duration-300 group-hover:translate-x-1"
        />
      </button>
      <p className="text-xs tracking-wide text-[#908B85]">
        Every enquiry is read personally by Caitlin. No call centres, no obligation.
      </p>
      </div>
    </form>
  );
};
